export const omitProps = (object, ...propNames) => {
  const omitted = { ...object };
  for (const propName of propNames) {
    delete omitted[propName];
  }
  return omitted;
};
